import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';

import { toggleModal, toggleSpinner } from '../../../actions/appAction';
import { INCREASE_LIMITS_CONTINUE_CLICKED, NOT_NOW_CLICKED } from '../../../constants/amplitude/AmplitudeEvents';
import { GT_LEVEL, KYC_PROVIDER } from '../../../constants/amplitude/AmplitudeParamName';
import { SUMSUB } from '../../../constants/amplitude/AmplitudeParamValues';
import { AUTH_SEND_MAIN_LINK } from '../../../constants/UrlConstants';
import { useExtra, usePageMessages } from '../../../hooks/selectors';
import { DangerouslyHtml } from '../../common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from '../../common/Layout/InfoPage/InfoPage';

const PromoReachingLimit = ({ primaryButtonOnClick, toggleSpinner }) => {
    const { reachingLimitTitle, reachingLimitSubTitle, upgradeLimitButton, notNowButton } = usePageMessages();
    const { current_aml_level, hasSumsub } = useExtra();
    const expectedGTLevel = current_aml_level + 1;

    const primaryButtonClickHandler = () => {
        const params = { [GT_LEVEL]: expectedGTLevel };
        if (hasSumsub) {
            params[KYC_PROVIDER] = SUMSUB;
        }
        amplitude.getInstance().logEvent(INCREASE_LIMITS_CONTINUE_CLICKED, params);
        primaryButtonOnClick();
    };

    return (
        <InfoPage
            iconName="speedometer-low-thin"
            iconColor="purple"
            headerText={<DangerouslyHtml dangerouslyHtml={reachingLimitTitle} />}
            secondaryText={<DangerouslyHtml dangerouslyHtml={reachingLimitSubTitle} />}
            topButtonType="link"
            topButtonCaption={notNowButton}
            topButtonLink={AUTH_SEND_MAIN_LINK}
            topButtonOnClick={() => {
                toggleSpinner(true);
                amplitude.getInstance().logEvent(NOT_NOW_CLICKED);
            }}
            primaryButtonCaption={upgradeLimitButton}
            primaryButtonOnClick={primaryButtonClickHandler}
        />
    );
};
export default connect(null, { toggleModal, toggleSpinner })(PromoReachingLimit);
